import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bannerkpi',
  templateUrl: './bannerkpi.component.html',
  styleUrls: ['./bannerkpi.component.css']
})
export class BannerkpiComponent implements OnInit {
  title='Documenti';
  kpi=11;
  kpidesc='documenti in attesa';
  kpicolor='kpicyan';
  subkpi=[
    {
      title:'da approvare',
      kpi:12
    },
    {
      title:'da approvare',
      kpi:12
    },
    {
      title:'da chiudere',
      kpi:2
    },
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
